module.exports = __webpack_public_path__ + "media/images/icon/icons8-Collect-fecd389f9868b8314a9257948ed0ea2a.png";